import SetAmount from './SetAmount';

export default SetAmount;
